module.exports = __webpack_public_path__ + "img/phonepluginckeck.bcbf224.svg";